module.exports = __webpack_public_path__ + "img/avatar.739297c3.png";